import {
  FormControl,
  Stack,
  TextField,
  Select,
  InputLabel,
  MenuItem,
  Tooltip,
  Button,
  Autocomplete
} from "@mui/material";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import React, { useEffect, useState, useContext, useCallback, useRef } from "react";
import { useSelector,useDispatch } from "react-redux";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { useTranslation } from "react-i18next";
import TPCheckbox from "../../TemplateProperties/TPCheckbox";
import { debounce,cloneDeep, isEmpty, has, isEqual } from "lodash";
import { eachDeep } from "deepdash-es/standalone";
import { treeActions } from "../../../redux/slices/treeSlice";
import { genericRules, validateOnFlow, validateRevertTime, validationTime } from "../../../utils/validate";
import { useGetDatatypePropertiesQuery } from "../../../redux/api";
import ItemPropertiesDelimiterInput from "../ItemPropertiesDelimiterInput";
import DelimiterInput from "../../TemplateProperties/DelimiterInput";
import { FieldPropHL7Datatype } from "./FieldPropHL7Datatype";

function FieldGroupProperties() {
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
  const { templateHeader } = rightTree.tree
  const selectedNode = rightTree.tree[rightTree.currentTab].selectedNode;
  const translatedData = rightTree.tree[rightTree.currentTab].translatedData;
  const {account} = useSelector((state) => state.queryParams);
  const dispatch = useDispatch();
  const [fieldGroupName, setFieldGroupName] = useState("");
  const [delimiter, setDelimiter] = useState('');
  const [errors,setErrors] = useState('');
  // const [hl7Datatype, setHl7Datatype] = useState("");
  const [elementId, setElementId] = useState("");
  const [repeatableField, setRepeatableField] = useState(false);
  const [fieldDelimiter, setFieldDelimiter] = useState(false);
  const [messageWarningIcon, setMessageWarningIcon] = useState(<HelpOutlineIcon sx={{fontSize: '26px', color: '#c4c4c4'}}/>);
  // const [hl7DatatypeDropdownItems,sethl7DatatypeDropdownItems] = useState([t('SELECT')])
  const errorRef = useRef();
//   const hl7DatatypeOptions = useGetDatatypePropertiesQuery({
//     account:account,
//     report_type:'hl7',
//     version:templateHeader?.FILETYPE_VERSION
// });
  // Adding the "--select--" option to the HL7 data type dropdown
  // useEffect(()=>{
  //   sethl7DatatypeDropdownItems([t('SELECT'), ...hl7DatatypeOptions.data?.data || []]);
  // },[hl7DatatypeOptions])

  useEffect(() => {
    const changedNode = rightTree.tree[rightTree.currentTab].selectedNode;
    if (changedNode) {
      setFieldGroupName(changedNode.TYPE || changedNode.DESCRIPTION || "");
      // setHl7Datatype(changedNode.HL7_DATA_TYPE || hl7DatatypeDropdownItems[0]);
      setRepeatableField(!!changedNode.REPEATING || false);
      setElementId(changedNode?.ELEMENT_ID || '');
    }
  }, [rightTree.tree[rightTree.currentTab].selectedNode.key]);
  
  const submitChange = (key,value) =>{
    if(key!=='TYPE' && key!=='HL7_DATA_TYPE' && key!=='REPEATING' && key!=='ELEMENT_ID'){
      return;
    }
    let newSelectedNode = cloneDeep(selectedNode);
    const updatedData = eachDeep(cloneDeep(translatedData), (objValue) => {
      if (objValue?.key !== selectedNode.key) {
        return;
      }
      if(key === 'TYPE'){
        objValue[key] = value;
        objValue.title = value;

      } else if (key === 'HL7_DATA_TYPE'){
        if(value === t('SELECT')){
          delete objValue[key]
       }
        else objValue[key] = value;
      } else if(key === 'REPEATING'){
        objValue[key] = value;
        objValue.ICON_DISPLAY = value ? "REPEATING_FIELD_GROUP" : "FIELD_GROUP";
      }else{
        objValue[key] = value;
      }

      newSelectedNode = objValue;
    })

    //prevent unnecessary dispatch
    if (isEqual(translatedData, updatedData)) return;

    dispatch(
      treeActions.setNewRightTreeTranslatedData({
        screen: parentScreen,
        type: rightTree.currentTab,
        data: updatedData,
      })
    );

    dispatch(
      treeActions.setRightTreeSelectedNode({
        screen: parentScreen,
        type: rightTree.currentTab,
        data: newSelectedNode,
      })
    );
  }

  const fieldGroupNameHandler = (e)=>{
    
    const {name, value} = e.target;
    const errorState = validateOnFlow(name, value,{
      [name] : {
        ...genericRules.noSlashRule,
        message: t('BOX_FLD_GRP_NAME_INVALID')
      }
    })

    setFieldGroupName(value);
    setErrors((prev) => ({
      ...prev,
      ...errorState
    }))

    if(isEmpty(errorState) || !value){
      debounceChangeHandler("TYPE", e.target.value);
    }

    if(!isEmpty(errorState)){
      setTimeout(()=>{
        setFieldGroupName((previousPrecisionValue) => {
          let val = previousPrecisionValue;
          val = val.replaceAll('/', '');
          return val;
        })
      },validateRevertTime)
    
    
      if(errorRef.current){
        clearTimeout(errorRef.current);
      }

      errorRef.current = setTimeout(() => {
        setErrors((previousErrorState) => {
          const copyPrev = JSON.parse(JSON.stringify(previousErrorState));
          delete copyPrev[name];
          return copyPrev;
        })
      }, validationTime)
    }
  }

  const blurHandler = (e)=>{
    const {value} = e.target;
    
    if(!value){
      const key = selectedNode?.key?.split('-')?.splice(1);
      key.splice(key.length - 1);

      // Nested Way to find selected node's parent children Array;
      let parentArray = translatedData;
      for(let i = 0;i<key.length;i++){
        parentArray = parentArray[key[i]]?.children || [];
      }
      const newName = fiedNameFinder(parentArray);
      debounceChangeHandler("TYPE", newName);
      setFieldGroupName(newName);
    }

  }

  const isParentFieldGroup = (selectedNode)=>{
    const key = selectedNode?.key || '';
    let keysArray = key?.split('-') || [];
    keysArray?.splice(keysArray.length - 1);
    keysArray = keysArray?.splice(1);
    let newData = translatedData;
    for(let i=0;i<keysArray?.length;i++){
      newData = newData?.[keysArray[i]];
      if(newData?.ICON_DISPLAY?.includes("FIELD_GROUP") && templateHeader.FILETYPE !== 'DELIM_FLD_ID') return false;
      newData = newData?.children || [];
    }
    return true;
  }

  const fiedNameFinder = (data) =>{
      let latestNewNodeNum = 0;
      data.forEach((ele, idx) => {
        // Checking if Unnamed is present already for creating next unnamed Field Group
        const fieldTitle = ele?.TYPE;
        if (fieldTitle && fieldTitle.startsWith(`${t("UNNAMED")}`) && ele?.ICON_DISPLAY?.includes('FIELD_GROUP')) {
          const latestUnnamedFieldGroup = Number(
            fieldTitle.slice(t("UNNAMED").length)
          );
          latestNewNodeNum =latestUnnamedFieldGroup > latestNewNodeNum ? latestUnnamedFieldGroup : latestNewNodeNum;
        }
      });
      return `${t("UNNAMED")}${latestNewNodeNum ? +latestNewNodeNum + 1 : 1}`
  }


  const debounceChangeHandler = useCallback(debounce(submitChange, 800), [
    rightTree.currentTab,
    rightTree.tree,
  ]);
  return (
    <>
      <Stack className="tp-segment" spacing={"15px"}>
        <FormControl>
          <TextField
            variant="outlined"
            size="small"
            autoComplete="off"
            type="text"
            className={"width-100"}
            label={t("LBL_FLDGRP_NAME_")}
            name={"FIELD_GROUP_NAME"}
            value={fieldGroupName}
            onChange={(e) => {
              fieldGroupNameHandler(e);
            }}
            helperText={errors?.FIELD_GROUP_NAME}
            error={has(errors,'FIELD_GROUP_NAME')}
            onBlur={blurHandler}
          />
        </FormControl>
        {(templateHeader.FILETYPE === "MULIT_DELIMITED" || templateHeader.FILETYPE === 'DELIM_FLD_ID') &&
          (
            <>
              <FormControl className="width-100" size="small">
              <ItemPropertiesDelimiterInput
                  default
                  label={t("LBL_FLD_DELIM_OVERRIDE_OPTIONAL")}
                  name={"DELIMITER"}
                />
              </FormControl>
            </>
          )
        }

        {
          templateHeader?.FILETYPE === 'EDI' && <>
          <FormControl>
            <TextField
              variant="outlined"
              size="small"
              autoComplete="off"
              type="text"
              disabled
              className={"width-100"}
              label={t("LBL_FLD_NUM")}
              value={selectedNode?.fieldNumber}
            />
          </FormControl>      
          <FormControl>
            <TextField
              variant="outlined"
              size="small"
              autoComplete="off"
              type="text"
              className={"width-100"}
              label={t("MAP_ELEMENT_ID")}
              value={elementId}
              onChange={(e) => {
                const {value} = e.target;
                debounceChangeHandler('ELEMENT_ID',value);
                setElementId(value);
              }}
            />
          </FormControl>
          </>
        }
        {(templateHeader?.FILETYPE === 'HL7') && 
          //  <div className="flex width-100">
          //  <FormControl variant="outlined" className="width-100" size="small">
          //  <Autocomplete
          //        freeSolo
          //        size='small'
          //        options={hl7DatatypeDropdownItems}
          //        value={hl7DatatypeDropdownItems?.length ? hl7Datatype : ""}
          //        onChange={(e,newValue) => {
          //         setHl7Datatype(newValue)
          //         debounceChangeHandler("HL7_DATA_TYPE", newValue);
          //       }}
          //       renderInput={(params) => (
          //         <TextField
          //           {...params}
          //           label={t("LBL_HL7_DATA_TYPE")}
          //           value={hl7DatatypeDropdownItems?.length ? hl7Datatype : ""}
          //           onChange={(e) => {
          //             setHl7Datatype(e.target.value);
          //             debounceChangeHandler("HL7_DATA_TYPE", e.target.value);
          //           }}
          //        />
          //       )}
          //       />
          //  </FormControl>
          //  {
          //      !messageWarningIcon ? '' :
          //      <Tooltip className="margin-left-4" title={t('BOX_HL7_DATA_TYPE_CHANGE_WARNING_OUTBOUND')} placement="right-start">
          //        <Button 
          //          sx={{
          //            width: '30px !important', 
          //            padding: '4px 8px !important', 
          //            minWidth: '30px !important'
          //          }}
          //          onClick={() => setMessageWarningIcon(false)}
          //          onMouseEnter={() => setMessageWarningIcon(<VisibilityOffIcon sx={{fontSize: '26px', color: '#c4c4c4'}}/>)}
          //          onMouseLeave={() => setMessageWarningIcon(<HelpOutlineIcon sx={{fontSize: '26px', color: '#c4c4c4'}}/>)}
          //        >
          //          {messageWarningIcon || ''}
          //        </Button>
          //      </Tooltip>
          //    }
          //  </div>
          <FieldPropHL7Datatype/>
        }
        
        <FormControl>
        {(templateHeader?.FILETYPE !== "EDI" || ["5010","5010H2"].includes(templateHeader?.FILETYPE_VERSION)) && isParentFieldGroup(selectedNode) && <TPCheckbox
          label={t("BTN_FLD_GRP_REPEATABLE")}
          checked={repeatableField}
          handleCheck={(checked) => {
            setRepeatableField(checked);
            debounceChangeHandler("REPEATING", checked);
          }}
        />}
        </FormControl>
      </Stack>
    </>
  );
}

export default FieldGroupProperties;
